import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Rocket } from 'lucide-react';

const Header = ({ scrollToSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: '¿Qué es Kompa?', id: 'que-es-kompa' },
    { label: 'Modalidades', id: 'ahorro-con-proposito' },
    { label: 'Planes', id: 'planes' },
    { label: 'FAQ', id: 'faq' },
  ];

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 w-full z-50 bg-black/70 backdrop-blur-xl border-b-2 border-[#fbb040]/30"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <motion.div 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="cursor-pointer" 
            onClick={() => scrollToSection('hero')}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_cb23de51-57d5-4133-8f16-28731c09c0ec/artifacts/6u7zs9oj_KOMPA%204.png" 
              alt="KOMPA" 
              className="h-16 md:h-20"
            />
          </motion.div>

          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item, index) => (
              <motion.button
                key={item.id}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05, color: '#fbb040' }}
                onClick={() => scrollToSection(item.id)}
                className="text-white font-bold text-lg transition-colors duration-200"
              >
                {item.label}
              </motion.button>
            ))}
          </nav>

          <motion.button 
            whileHover={{ 
              scale: 1.05, 
              boxShadow: "0 0 30px rgba(251, 176, 64, 0.6)"
            }}
            whileTap={{ scale: 0.95 }}
            onClick={() => scrollToSection('planes')}
            className="hidden lg:flex items-center gap-2 bg-gradient-to-r from-[#fbb040] to-yellow-400 text-black px-8 py-4 rounded-full font-black text-lg shadow-2xl"
          >
            <Rocket size={24} />
            Activar mi meta
          </motion.button>

          <button className="lg:hidden text-[#fbb040]" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={32} /> : <Menu size={32} />}
          </button>
        </div>

        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="lg:hidden overflow-hidden"
            >
              <nav className="flex flex-col space-y-4 py-4">
                {navItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => { scrollToSection(item.id); setIsMenuOpen(false); }}
                    className="text-left text-white font-bold text-lg"
                  >
                    {item.label}
                  </button>
                ))}
                <button 
                  onClick={() => { scrollToSection('planes'); setIsMenuOpen(false); }}
                  className="bg-gradient-to-r from-[#fbb040] to-yellow-400 text-black px-6 py-3 rounded-full font-black"
                >
                  Activar mi meta
                </button>
              </nav>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.header>
  );
};

export default Header;